import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
interface Crumb {
  label: string;
  to?: string;
}
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  crumbs?: Crumb[];
}
export function PageHeader({
  eyebrow,
  title,
  description,
  crumbs = []
}: PageHeaderProps) {
  return <section className="border-b border-navy-800 bg-navy-950" data-id="element-164" data-mp="3mdoh933moeob">
      <div className="mx-auto max-w-content px-6 py-16 sm:py-20 lg:px-8" data-id="element-165" data-mp="2yqq5ujud7wx9">
        {crumbs.length > 0 && <nav aria-label="Breadcrumb" className="mb-8" data-id="element-166" data-mp="2tsew0942lmf1">
            <ol className="flex flex-wrap items-center gap-2 text-[13px] text-navy-400" data-id="element-167" data-mp="38g9p3qlzpssn">
              <li data-id="element-168" data-mp="33pb3cbi8g2i0">
                <Link to="/" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-169" data-mp="33orjuqcxp61v">
                  Home
                </Link>
              </li>
              {crumbs.map(crumb => <li key={crumb.label} className="flex items-center gap-2" data-id="element-170" data-mp="2ayjbfq87a00h">
                  <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="2hyq01cvskfo0" />
                  {crumb.to ? <Link to={crumb.to} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-172" data-mp="2lygxfzftpu1i">
                      {crumb.label}
                    </Link> : <span className="text-navy-200" data-id="element-173" data-mp="1z1feev331kr1">{crumb.label}</span>}
                </li>)}
            </ol>
          </nav>}
        {eyebrow && <p className="mb-4 text-[12px] uppercase tracking-[0.2em] text-gold-300" data-id="element-174" data-mp="27zr0qkwx1wdo">
            {eyebrow}
          </p>}
        <h1 className="max-w-3xl font-serif text-[34px] leading-[1.1] tracking-tight text-white sm:text-[46px]" data-id="element-175" data-mp="2d16mkf6x46x4">
          {title}
        </h1>
        {description && <p className="mt-6 max-w-2xl text-[18px] leading-relaxed text-navy-200" data-id="element-176" data-mp="3odzdjnrvwrc4">
            {description}
          </p>}
      </div>
    </section>;
}